import React from 'react';
// The Sikh Initiative wordmark logo. The PNG ships with its own ivory
// background, so we render it cleanly without an extra wrapping tile —
// just rounded corners so it feels intentional on dark surfaces.
export const Logo = ({
  className = '',
  height = 56
}: {
  className?: string;
  height?: number;
}) => <img src="https://cdn.magicpatterns.com/uploads/7vCN5oktYYPnrNehqJ1hT6/image.png" alt="The Sikh Initiative" style={{
  height
}} className={`object-contain w-auto rounded-md ${className}`} data-id="element-274" />;
export const FullLogo = ({
  className = '',
  height = 80
}: {
  className?: string;
  height?: number;
}) => <img src="https://cdn.magicpatterns.com/uploads/dLxtYH1HxWkharpySNQtya/image.png" alt="Khalsa Civic Leadership Fellowship — Leadership · Entrepreneurship · Civic Impact" style={{
  height
}} className={`object-contain w-auto ${className}`} data-id="element-275" />;